// extracted by mini-css-extract-plugin
export var callCard = "_p0-0";
export var callMessageButton = "_p0-1";
export var helpIcon = "_p0-3";
export var helpIconContainer = "_p0-4";
export var verticalDivider = "_p0-2";